@let activeGroupValue = activeGroup();
@let groupsValue = groups();

@if (groupsValue) {
  @for (group of groupsValue!; track group.id) {
    @if (group.canView) {
      <rt-box
        [class.card-clickable]="activeGroupValue?.id !== group.id && activeGroupValue?.canEdit"
        class="card"
        variant="vertical"
        (click)="setGroupOnClicked(group)"
      >
        <rt-heading variant="heading">
          <rt-radio
            [class.card-no-clickable]="activeGroupValue?.id === group.id"
            [hasLensIcon]="true"
            [checked]="activeGroupValue?.id === group.id"
            [disabled]="!activeGroupValue?.canEdit"
            (click)="setGroupOnClicked(group)"
          />
          {{ texts.groups[group.id].heading }}
        </rt-heading>
        <div class="body">
          <div
            [attr.margin-bottom-small]="
              activeGroupValue?.id === group.id && group.abilities.length ? true : null
            "
          >
            {{ texts.groups[group.id].description }}
          </div>

          @if (activeGroupValue?.id === group.id) {
            @for (entry of group.abilities; track entry; let last = $last) {
              @if (!entry.hidden) {
                @let memberHasAbility = !!form.get(entry.id)!.value;
                <div [attr.margin-bottom-small]="!last ? true : null">
                  <rt-checkbox
                    [checked]="memberHasAbility"
                    [formControl]="$any(form.get(entry.id)!)"
                    rtProtectedControl
                  >
                    <span class="checkbox-label">{{ texts.abilities[entry.id].name }}</span
                    ><br />
                    <span [class.text-default]="memberHasAbility">{{
                      texts.abilities[entry.id].description
                    }}</span>
                  </rt-checkbox>
                </div>
              }
            }
          }
        </div>
      </rt-box>
    }
  }
}
